<template>
	<div>
		<h4 class="mb-3">{{ $t('review-students') }}</h4>

		<b-alert show variant="danger" class="mb-2" v-for="(issue, i) in columnIssues" :key="i">
			{{ issue }}
		</b-alert>

		<b-alert show variant="success" class="mb-2" v-if="unmatchedCount === 0">
			{{ $t('all-{n}-rows-matched-to-a-student', { n: rows.length }) }}
		</b-alert>
		<b-alert show variant="warning" class="mb-3" v-else>
			<strong>{{ unmatchedCount }} {{ $t('rows-have-no-matched-student') }}</strong>
			{{ $t('assign-them-manually-below-or-they-will-be-skipped-when-saving') }}
		</b-alert>

		<div class="table-responsive mb-3">
			<table class="table table-sm table-bordered">
				<thead class="thead-light">
					<tr>
						<th style="width:3rem">{{ $t('row') }}</th>
						<th v-if="studentIdColumnIndex !== null">{{ $t('csv-identifier') }}</th>
						<th>{{ $t('student') }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(row, index) in rows" :key="index"
						:class="{ 'table-warning': !datastudents[index].displayName }">
						<td class="text-muted">{{ index + 1 }}</td>
						<td v-if="studentIdColumnIndex !== null" class="small text-muted">
							{{ row[studentIdColumnIndex] }}
						</td>
						<td>
							<div class="input-group input-group-sm">
								<input type="text" :value="datastudents[index].displayName" class="form-control"
									readonly
									@focus="$emit('select-student', index)"
									:style="datastudents[index].displayName === null ? 'border-color: #ef4444' : ''" />
								<div class="input-group-append">
									<span class="input-group-text" @click="$emit('deselect-student', index)">
										<b-icon icon="trash-fill" aria-hidden="true"></b-icon>
									</span>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="d-flex">
			<b-button variant="outline-secondary" class="mr-2" @click="$emit('back')">← {{ $t('back') }}</b-button>
			<b-button variant="primary" :disabled="!canSave || importing" @click="$emit('import')">
				<b-spinner v-if="importing" small class="mr-1"></b-spinner>
				{{ importing ? $t('saving') : $t('save') }}
			</b-button>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		rows:                 { type: Array,  required: true },
		datastudents:         { type: Array,  required: true },
		studentIdColumnIndex: { type: [Number, String], default: null },
		columnIssues:         { type: Array,  default: () => [] },
		importing:            { type: Boolean, default: false },
	},
	computed: {
		unmatchedCount() {
			return this.datastudents.filter(s => !s.displayName).length;
		},
		canSave() {
			return this.columnIssues.length === 0 && this.datastudents.some(s => s.displayName);
		},
	},
};
</script>
